/**
 * AuthRequest
 * @author Simpli CLI generator
 */
import {$, Model, sleep} from 'simpli-web-sdk'
import {
  ResponseHidden,
  ValidationCNPJ,
  ValidationMaxLength,
  ValidationPasswordLength,
} from 'simpli-web-sdk'

export default class AuthRequest extends Model {
  readonly $name: string = 'AuthRequest'

  @ValidationMaxLength(255)
  cnpj: string | null = null

  @ResponseHidden()
  @ValidationPasswordLength(6, 100)
  senha: string | null = null

  captchaResultCode: string | null = null

  codigoVerificacao: string | null = null
}
